import React, { ReactNode } from 'react';
import classNames, { Argument } from 'classnames';

import Label from 'types/Label';
import Language from 'types/LanguageEnum';
import { DEFAULT_LANGUAGE } from 'constants/LanguageConstants';

import { getUrlParam } from './urlUtils';

const LANGUAGE_OVERRIDES: Partial<Record<Language, Array<string>>> = {
  [Language.NO]: [Language.NO, 'nb', 'nn'],
  [Language.LV_LV]: [Language.LV_LV, 'lv'],
  [Language.LT_LT]: [Language.LT_LT, 'lt'],
  [Language.DA_DK]: [Language.DA_DK, 'da'],
  [Language.EL_GR]: [Language.EL_GR, 'el'],
  [Language.ET_EE]: [Language.ET_EE, 'et'],
  [Language.FI_FI]: [Language.FI_FI, 'fi'],
  [Language.HR_HR]: [Language.HR_HR, 'hr'],
  [Language.JA_JP]: [Language.JA_JP, 'ja'],
  [Language.RO_RO]: [Language.RO_RO, 'ro', 'mo'],
};

export const getDefaultLanguage = () => {
  const languageParam = getUrlParam('language');

  // Language can be RFC-5646 compliant (en-GB, fr-BE, ...)
  const navigatorLanguage = navigator.languages[0]?.split('-')?.shift();

  const userLanguage = languageParam ?? navigatorLanguage;
  const override = Object.entries(LANGUAGE_OVERRIDES).find(
    ([, overridenLangs]) => overridenLangs.includes(userLanguage),
  )?.[0];

  const formattedLanguage = (override ?? userLanguage) as Language;
  return Object.values(Language).find((language) => language === formattedLanguage) ?? DEFAULT_LANGUAGE;
};

export const b = (text: ReactNode, className?: Argument) => (
  <span className={classNames('font-bold', className)}>{text}</span>
);
export const i = (text: ReactNode) => (<span className="italic">{text}</span>);
export const br = <br />;

export const link = (props: React.HTMLAttributes<HTMLSpanElement> & { 'data-testid'?:string }) => (text: ReactNode) => (
  <span {...props} className={classNames('underline text-black cursor-pointer select-none', props.className)}>{text}</span>
);

/**
 * Usage:
 **    const language = useSelector(getSelectedLanguage);
 **    const translation = getLabelTranslation(name, language);
 */
// eslint-disable-next-line max-len
export const getLabelTranslation = (label: Label = {}, language: Language) => label[language] ?? label[DEFAULT_LANGUAGE] ?? Object.values(label)[0];
